import { createAction } from 'redux-act';
import mixpanel from 'mixpanel-browser';
import runtimeEnv from '@mars/heroku-js-runtime-env';
import { switchToSecondTeam } from '../../../api/signUp';
import { getLeagueCodeName } from '../../../api/league';
import { previewLoginRequest, leaveTeamCall } from '../../../api/user';
import { logoutLink, loginLink } from '../../../service/links';
import { toastRender } from '../../../service/toaster';
import { addNotificationPopupRequest } from '../Popups';
import { sidebarGetDataForSideBar } from '../Sidebar';
import { getYouthCampStatusRequest } from '../YouthCamp';
import { resetClubScopedState } from '../clubSwitch';
import { resetAnalytics } from '../../../service/analytics';

export const login = createAction('login user in site');
export const logout = createAction('logout user from site');
export const testAuthUser = createAction('test if user authorized');
export const testAuthLoader = createAction('show loader when tested auth');
export const loggedAsWaited = createAction('user logged as waiter');
export const loginTeam = createAction('Login with team data');
export const setLeagueName = createAction('Set league name');
export const leaveTeam = createAction('Leave team request');
export const isLoggingOut = createAction('Logout started');
export const setClubSwitchLoading = createAction('set club switch loading');

const applySessionJson = (dispatch, json) => {
  try {
    mixpanel.identify(json.user_id);
    mixpanel.people.set({
      $name: json.username,
      user_team: json.user_team?.name,
      user_id: json.user_id,
    });
  } catch { /* Optional analytics must not block login or club switching. */ }
  dispatch(
    login({
      isAuth: true,
      discord: json.discord_id,
      team_info: json.user_team,
      username: json.username,
      avatarID: json.avatar,
      isPremium: json.isPremium,
    })
  );
};

export const userLogout = () => async (dispatch) => {
  // const env = runtimeEnv();
  // const { REACT_APP_LINK } = env;
  const response = await fetch(logoutLink, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    credentials: 'include',
  });
  dispatch(isLoggingOut(true));
  if (response.status === 200) {
    // Clear the Mixpanel identity so the next account on this browser does not
    // merge into this one; re-registers platform: 'web'. Never throws.
    resetAnalytics();
    window.location.href = process.env.REACT_APP_LINK;
    dispatch(logout());
  }
};

export const setAuthError = createAction('set authentication error');
let authInFlight = false;
export const testAuth = () => async (dispatch, getState) => {
  if (authInFlight) return;
  authInFlight = true;
  dispatch(setAuthError(false));
  dispatch(testAuthLoader({ loader: true }));
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetch(loginLink, {
      signal: controller.signal,
      method: 'GET',
      headers: { 'Content-Type': 'application/json;charset=utf-8' },
      credentials: 'include',
    });
    if (response.status === 200) {
      applySessionJson(dispatch, await response.json());
    } else if (response.status === 201) {
      const json = await response.json();
      try {
        mixpanel.identify(json.user_id);
        mixpanel.people.set({ $name: json.username, user_team: 'None', user_id: json.user_id });
      } catch { /* Optional analytics must not block login. */ }
      dispatch(loggedAsWaited({ isAuthLikeWithoutTeam: true, discord: json.discord_id }));
      dispatch(addNotificationPopupRequest({
        name: 'noTeamPopup',
        message: 'It seems you do not own a team yet. Please select a league and a team first.',
      }));
    } else if ([401, 403, 406].includes(response.status)) {
      // A concurrent GET /login can finish after Discord POST /login and
      // race ahead of the session cookie — never wipe an established session.
      if (getState()?.user?.isAuth === true) return;
      dispatch(testAuthUser({ isAuth: false }));
    } else {
      dispatch(setAuthError(true));
    }
  } catch {
    if (getState()?.user?.isAuth === true) return;
    dispatch(setAuthError(true));
  } finally {
    clearTimeout(timeout);
    authInFlight = false;
    dispatch(testAuthLoader({ loader: false }));
  }
};

export const previewLogin = (teamId, teamName) => async (dispatch) => {
  const response = await previewLoginRequest(teamId);
  if (response.status === 200) {
    const data = await response.json();
    let teamData;
    if (!teamId && !teamName) {
      teamData = {
        id: data.teamId,
        name: data.teamName,
      };
    } else {
      teamData = { id: teamId, name: teamName };
    }
    localStorage.setItem('previewTeamData', JSON.stringify(teamData));
    dispatch(
      login({
        team_info: {
          name: teamData.name,
          _id: teamData.id,
        },
      })
    );
  }
};

export const userLogin = (access_token) => async (dispatch) => {
  const response = await fetch(loginLink, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
    },
    credentials: 'include',
    body: JSON.stringify({ access_token }),
  });

  if (response.status === 200) {
    const json = await response.json();
    mixpanel.identify(json.user_id);
    mixpanel.people.set({
      $name: json.username,
      user_team: json.user_team.name,
      user_id: json.user_id,
      username: json.username,
      avatarID: json.avatar,
    });
    // alert("YOU LOGGED AS MEMBER");
    dispatch(
      login({
        isAuth: true,
        discord: json.discord_id,
        team_info: json.user_team,
        username: json.username,
        avatarID: json.avatar,
        isPremium: json.isPremium,
      })
    );

    // alert(`RECIVED DATA AFTER LOGGINING - ${JSON.stringify(json)}`);
  } else if (response.status === 201) {
    const json = await response.json();
    mixpanel.identify(json.user_id);
    mixpanel.people.set({
      $name: json.username,
      user_team: 'None',
      user_id: json.user_id, 
    });
    // alert("YOU LOGGED AS WAITED");
    dispatch(
      addNotificationPopupRequest({
        name: 'noTeamPopup',
        message:
          'It seems you do not own a team yet. Please select a league and a team first.',
      })
    );
    dispatch(
      loggedAsWaited({
        isAuthLikeWithoutTeam: true,
        discord: json.discord_id,
      })
    );
  } else if (response.status === 406) {
    dispatch(login({ isAuth: null }));
  } else {
    dispatch(login({ isAuth: false }));
  }
};

export const getLeagueName = () => async (dispatch) => {
  const response = await getLeagueCodeName();
  if (response.status === 200) {
    const data = await response.json();
    dispatch(setLeagueName(data));
  }
};

export const switchActiveClub = (history) => async (dispatch) => {
  dispatch(setClubSwitchLoading(true));
  try {
    const switchResponse = await switchToSecondTeam();
    if (switchResponse.status !== 200) {
      toastRender('error', 'Could not switch club. Please try again.');
      return false;
    }

    const sessionResponse = await fetch(loginLink, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      credentials: 'include',
    });
    if (sessionResponse.status !== 200) {
      window.location.reload();
      return false;
    }

    const sessionJson = await sessionResponse.json();
    dispatch(resetClubScopedState());
    applySessionJson(dispatch, sessionJson);

    if (history?.location?.pathname?.includes('/home/player/')) {
      history.replace('/home');
    }

    await Promise.all([
      dispatch(sidebarGetDataForSideBar()),
      dispatch(getLeagueName()),
      dispatch(getYouthCampStatusRequest()),
    ]);
    return true;
  } catch (error) {
    toastRender('error', 'Could not switch club. Please try again.');
    return false;
  } finally {
    dispatch(setClubSwitchLoading(false));
  }
};

export const leaveTeamRequest = () => async (dispatch) => {
  const response = await leaveTeamCall();
  if (response.status === 200) {
    dispatch(leaveTeam(true));
  }
};
